import APIClient from '@/shared/http/clients/api'

const resourceName = 'card/cobranca'
const resourceNameCob = 'cobranca'
const APICore = process.env.APIBaseURLCore

const GetAll = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?situacao=ATIVO&page=${index}&size=${limit}&sort=posicao`, config)
const Search = (fixedFilters, filter = '', limit, index, sortValue = 'posicao', config = {}) => APIClient.get(`${APICore}/${resourceName}/?${fixedFilters}${filter != null ? filter : ''}&page=${index}&size=${limit}`, config)
const RefreshDashboard = (fixedFilters, filter = '', config = {}) => APIClient.get(`${APICore}/${resourceName}-dashboard/?${fixedFilters}${filter != null ? filter : ''}`, config)

const RefreshUpdatesDashboard = (evento, config = {}) => APIClient.get(`${APICore}/${resourceNameCob}/?tipoCobrancaEvento=${evento}`, config)
const SearchUpdates = (evento, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceNameCob}/?tipoCobrancaEvento=${evento}&page=${index}&size=${limit}`, config)

const CobrancaCardRepository = {
  GetAll,
  Search,
  RefreshDashboard,
  RefreshUpdatesDashboard,
  SearchUpdates
}

export default CobrancaCardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/cardCobranca.js